import type { ImportRow } from "./itemImport.api";
import { importRowStatus } from "./itemImportRowStatus";

export type ImportSelectionCondition = "all" | "none" | "unchecked" | "ready";

export function canSelectImportRow(row: ImportRow): boolean {
  return !row.completed && !row.duplicate && !row.over_limit
    && Boolean(row.shop_id) && Object.keys(row.errors).length === 0;
}

export function canRegisterImportRow(row: ImportRow): boolean {
  return canSelectImportRow(row) && !row.needs_check && Boolean(row.shop_item_gid);
}

export function selectedImportRows(rows: ImportRow[]): ImportRow[] {
  return rows.filter((row) => row.selected);
}

export function selectImportRows(rows: ImportRow[], condition: ImportSelectionCondition): ImportRow[] {
  return rows.map((row) => ({
    ...row,
    selected: condition !== "none" && canSelectImportRow(row)
      && (condition === "all" || importRowStatus(row).label === (condition === "unchecked" ? "미확인" : "등록대기")),
  }));
}

export function canCheckImportSelection(rows: ImportRow[]): boolean {
  const selected = selectedImportRows(rows);
  return selected.length > 0 && selected.every((row) => canSelectImportRow(row) && !row.needs_check);
}

export function canRegisterImportSelection(rows: ImportRow[]): boolean {
  const selected = selectedImportRows(rows);
  return selected.length > 0 && selected.every(canRegisterImportRow);
}
